// import media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar5 from 'assets/images/avatar/avatar-5.jpg';

export const AuthorData = [
	{
		id: 1,
		author_name: 'Jenny Wilson',
		author_image: Avatar1,
		designation: 'Front-end Developer, Designer',
		rating: 4.5,
		students: 110124,
		courses: 42,
		about_author: `I start my development and digital career studying digital design. 
        After taking a couple of programming classes I realize that code is what I wanted to be doing.`
	},
	{
		id: 2,
		author_name: 'Paulina Rush',
		author_image: Avatar2,
		designation: 'Front-end Developer, Designer',
		rating: 4.5,
		students: 12124,
		courses: 8,
		about_author: `Writing JS, CSS, and HTML professionally since 2004. 
        Open source contributor to projects like jQuery, jQueryUI, ESLint, Webpack, npm, JSCS, Esprima and more.`
	},
	{
		id: 3,
		author_name: 'Avneet Brooks',
		author_image: Avatar3,
		designation: 'Front-end Developer, Designer',
		rating: 4.5,
		students: 23000,
		courses: 23,
		about_author: `Software developer and active open sorcerer. She speaks multiple languages and is often overheard saying "Bonjour" in HTML.`
	},
	{
		id: 4,
		author_name: 'Bree Head',
		author_image: Avatar5,
		designation: 'Front-end Developer, Designer',
		rating: 4.5,
		students: 40244,
		courses: 22,
		about_author: `Bree Head developer, architect, occasional designer, and frequent speaker. 
        He’s passionate about building tools, systems, and create high-performance teams and apps.`
	}
];

export default AuthorData;
